<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<realWarehouse v-if="activeTab == '1'" ref="realWarehouse"></realWarehouse>
			<twoDimension v-if="activeTab == '2'" ref="twoDimension"></twoDimension>
			<qtySnapshotRecord v-if="activeTab == '3'" ref="qtySnapshotRecord"></qtySnapshotRecord>
			<qtyChangeLog v-if="activeTab == '4'" ref="qtyChangeLog"></qtyChangeLog>
		</topTab>
	</div>
</template>

<script>
import realWarehouse from "./realWarehouse.vue";
import twoDimension from "./twoDimension.vue";
import qtySnapshotRecord from "./qtySnapshotRecord.vue";
import qtyChangeLog from "./qtyChangeLog.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "实时库存"
				},
				{
					key: "2",
					value: "二维表库存"
				},
				{
					key: "3",
					value: "库存记录"
				},
				{
					key: "4",
					value: "库存手动变更记录"
				}
			]
		};
	},
	// 注册组件
	components: {
		realWarehouse,
		twoDimension,
		qtySnapshotRecord,
		qtyChangeLog
	},
	created() {},
	computed: {},
	methods: {
		changePages(tab) {
			this.activeTab = tab;
		}
	}
};
</script>

<style scoped>

</style>
